import { unwrapSettingsRows } from "../utils/schemaForm";

export { toRequestQuery } from "../../../shared/api/transformers";

export function extractTargetGroups(data) {
  const raw = data?.settings_json;
  return Array.isArray(raw) ? raw : unwrapSettingsRows(data);
}
